export function imageResize(url: string | undefined): string | undefined {
  if (url && url.indexOf('/image/upload/') !== -1) {
    return url.replace('/image/upload/', '/image/upload/c_fill,h_400,w_400/');
  }
  return url;
}
